import { useState, useEffect } from 'react'
import { Softphone } from '@/components/twilio/Softphone'

export function SoftphoneWrapper() {
  const [isOpen, setIsOpen] = useState(false)
  const [phoneNumber, setPhoneNumber] = useState('')
  const [subjectType, setSubjectType] = useState<'agent' | 'client' | 'organization' | undefined>()
  const [subjectId, setSubjectId] = useState<string | undefined>()

  useEffect(() => {
    // Listen for broadcast messages to open softphone
    const channel = new BroadcastChannel('softphone')

    channel.onmessage = (event) => {
      const { action, phoneNumber: number, subjectType: type, subjectId: id } = event.data

      if (action === 'open' && number) {
        setPhoneNumber(number)
        setSubjectType(type)
        setSubjectId(id)
        setIsOpen(true)
      } else if (action === 'close') {
        setIsOpen(false)
      }
    }

    return () => {
      channel.close()
    }
  }, [])

  if (!isOpen) {
    return null
  }

  return (
    <Softphone
      initialNumber={phoneNumber}
      subjectType={subjectType}
      subjectId={subjectId}
      onClose={() => setIsOpen(false)}
    />
  )
}
